import React, { useState } from 'react';
import CustomModal from '../../../../custom/modal/customModal';
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { PackageApi, UnitApi } from '../../../../App/api/setting';
import { toast } from 'react-toastify';

function PackageMasterModel({ isOpen, onClose, data, fetchAllData }) {

    const formik = useFormik({
        initialValues: {
            packaging_name: data?.packaging_name || "",
            packaging_type: data?.packaging_type || ""
        },
        onSubmit: async(values) => {
            console.log("packaging values:",values);
            try {
            if (data?._id) {
            
                await PackageApi.master.updatePackageMaster(data?._id,values); 
                fetchAllData();
                toast.success("Package Master Updated Successfully")
                handleClose();
            } else {
                await PackageApi.master.createPackageMaster(values); 
                fetchAllData();
                toast.success("Package Master Created Successfully")
                handleClose();
            }
        }catch (err) {
            toast.error(`Error: ${err.message || "Something went wrong"}`);
        }
    },
        validate: (values) => {
            const errors = {};
            if (!values.packaging_name) errors.packaging_name = "Packaging Name is required";
            if (!values.packaging_type) errors.packaging_type = "Packaging Type is required";
            return errors;
        },
    });
    
    const handleClose = () => {
        formik.resetForm(); 
        onClose();
    };

    
    
    return (
       
        <CustomModal isOpen={isOpen} onClose={handleClose} title="Add Unit Details">
    <form onSubmit={formik.handleSubmit} className="mt-4">
        {/* Unit Name Input */}
        <div className="mb-4">
            <label className="block text-gray-700 text-lg">
                Enter Packaging Name
            </label>
            <input
                value={formik.values.packaging_name}
                onChange={(e) => formik.setFieldValue("packaging_name", e.target.value)}
                className="mt-1 block h-10 p-2 w-full border rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                placeholder="Enter Packaging name (e.g., Standard Box, Eco-Friendly Wrap)"
            />
            {formik.touched.packaging_name && formik.errors.packaging_name && (
                <p className="text-red-500 text-sm mt-1">
                    {formik.errors.packaging_name}
                </p>
            )}
        </div>

        {/* Unit Value Input */}
        <div className="mb-4">
            <label className="block text-gray-700 text-lg">
                Enter Packaging Type <span className='text-sm'>(e.g., mm, kg)</span>
            </label>
            <input
                value={formik.values.packaging_type}
                onChange={(e) => formik.setFieldValue("packaging_type", e.target.value)}
                className="mt-1 block w-full h-10 p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50"
                placeholder="Enter Packaging Type (e.g., Box, Bag, Pouch, Wrap)"
            />
            {formik.touched.packaging_type && formik.errors.packaging_type && (
                <p className="text-red-500 text-sm mt-1">
                    {formik.errors.packaging_type}
                </p>
            )}
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-3">
            <button
                type="button"
                onClick={handleClose}
                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
            >
                Cancel
            </button>
            <button
                type="submit"
                className="bg-[--color--2] text-white px-4 py-2 rounded hover:bg-[--color--1]"
            >
                {data?._id ?"Update":"Save"}
            </button>
        </div>
    </form>
</CustomModal>

    );
}

export default PackageMasterModel;
